import type { FormField } from '@klp/formgenerator/interfaces';

export enum CamundaFields {
    // Special fields
    TILDEL_KOMMENTARER = 'TildelKommentarer',
    ROLLE_KOMMENTARER = 'rolleKommentarer',

    // String type fields
    MAIN_TITLE = 'MainTitle',
    H2_TITLE = 'h2Title',
    H3_TITLE = 'h3Title',
    TEXT = 'text',
    ALERT_INFO = 'alertInfo',
    ALERT_WARNING = 'alertWarning',
    LINK_EDITABLE = 'linkEditable',
    LINK = 'link',
    RADIOBUTTON = 'radiobutton',
    CHECKBOX = 'checkbox',
    DROPDOWN = 'dropdown',
    TEXTAREA = 'textarea',
    CONDITIONAL_DROPDOWN = 'conditionalDropdown',
    BRONNOYSUND = 'bronnoysund',
    EIENDOMSNAVN = 'eiendomsnavn',
    BUDSJETTNUMMER = 'budsjettnummer',
    BUDSJETTINFO_MULTIPLE = 'budsjettinfoMultiple',
    BUDSJETTINFO = 'budsjettinfo',
    VURDERINGSSKJEMA = 'vurderingsskjema',
    VURDERINGSSKJEMA_OPPSUMMERING = 'vurderingsskjemaOppsummering',
    CONDITIONAL = 'conditional',
    LEVERANDOR_LISTE = 'leverandorListe',
    VEDLEGG_SINGLE = 'vedlegg',
    VEDLEGG_LISTE = 'vedleggListe',
    AVFALL_DOKUMENT = 'avfallDokument',
    GARANTI_DOKUMENT_UPLOAD = 'garantiDokumentUpload',
    GARANTI_DOKUMENT_SELECT = 'garantiDokumentSelect',
    KOSTNADSKALKYLE = 'kostnadskalkyle',
    CALCULATED_EDITABLE = 'calculatedEditable',
    BRANSJE = 'bransje',
    RISIKOVURDERING = 'risikovurdering',
    LEVERANDOR_KLASSIFISERING = 'leverandorKlassifisering',
    LEVERANDOR_DEVIATION_ALERT = 'leverandorDeviationAlert',

    // Long type fields
    PERCENTSLIDER = 'percentslider',
    PERCENTFIELD = 'percentfield',
    CALCULATED = 'calculated',
    RISK_CALCULATED = 'samletRisiko',

    // Boolean type fields
    CONSTANT = 'constant',
    BUDSJETTERT = 'budsjettert',
    IDE_BUDSJETTERT = 'ideBudsjettert',
    GARANTI_MOTTATT = 'garantiMottatt',
    PROSJEKTLEDER_BEKREFTELSE = 'prosjektlederBekreftelse',
    CONDITIONAL_LINK_SELECTOR = 'conditionalLinkSelector',
}

export const findCamundaValue = (
    fieldId: string,
    formFields: Array<FormField>,
): string | undefined => {
    const field = formFields.find((f) => f.id === fieldId);
    return field?.value;
};
